module.exports = __webpack_public_path__ + "static/media/lbs-background.d35a6717.png";